var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _polygon;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgSpaces = function SvgSpaces(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e9041e7e-36d6-4be0-8fa3-bd4d22e774f7",
    "data-name": "spaces",
    viewBox: "0 0 79.48 79.48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 52.41,
    y: 1.47,
    width: 2.94,
    height: 49.69
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 1.47,
    y: 49.69,
    width: 22.64,
    height: 2.94
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 35.43,
    y: 49.69,
    width: 30.19,
    height: 2.94
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 22.64,
    y: 61.22,
    width: 2.94,
    height: 15.09
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 52.41,
    y: 62.05,
    width: 2.94,
    height: 15.96
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 53.88,
    y: 22.85,
    width: 24.14,
    height: 2.94
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    x: 28.39,
    y: 22.85,
    width: 24.14,
    height: 2.94
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "b295b9fa-11fa-42c9-8bb1-ff8a7e021953",
    points: "76.55 22.68 76.55 76.55 2.94 76.55 2.94 2.94 55.56 2.94 55.56 0 0 0 0 79.48 79.48 79.48 79.48 22.68 76.55 22.68"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSpaces, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spaces.af7bf54e.svg";
export { ForwardRef as ReactComponent };